import { query } from '@confluence/query-preloader-tools';

import { BreadcrumbsQuery } from './BreadcrumbsQuery.graphql';

export function preloadBreadcrumbs(spaceKey, contentId, skipContent = false) {
	return query({
		query: BreadcrumbsQuery,
		variables: {
			spaceKey,
			contentId,
			skipContent,
		},
		fetchPolicy: 'network-only',
	});
}
